// Module
var code = "<preferences-sidebar disabled=true></preferences-sidebar> <ui-view></ui-view> ";
// Exports
module.exports = code;